import styled from "styled-components";
import { purpleColor } from "../../constants/colors";

const ConnectingBlock = styled.div`
  padding-top: 53px;
  padding-bottom: 75px;
  //min-height: 100vh;
  flex-grow: 1;
  box-sizing: border-box;
  display: flex;
  @media (max-width: 767px) {
    padding-top: 40px;
    padding-bottom: 25px;
  }
`;

ConnectingBlock.Wrapper = styled.div`
  //padding-top: 40px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  flex-grow: 1;
  height: 100%;
`;
ConnectingBlock.Top = styled.div``;

ConnectingBlock.Top.Title = styled.div`
  margin-bottom: 25px;
`;
ConnectingBlock.Top.Text = styled.div`
  margin-bottom: 25px;
`;
ConnectingBlock.Top.Img = styled.div`
  margin-bottom: 9px;
  img {
    max-width: 100%;
    @media (max-width: 767px) {
      max-width: 320px;
    }
  }
`;
ConnectingBlock.Top.Double = styled.div`
  display: flex;
  margin-bottom: 30px;
`;
ConnectingBlock.Comment = styled.div`
  position: relative;
  object-fit: contain;
`;
ConnectingBlock.Comment.Item = styled.div`
  position: absolute;
  bottom: 11px;
  left: 10px;
  width: calc(100% - 20px);
  padding: 18px 15px 18px 12px;
  background: rgba(0, 0, 0, 0.54);
  backdrop-filter: blur(12px);
  border-radius: 12px;
  box-sizing: border-box;
  @media (max-width: 767px) {
    max-width: 300px;
    margin: 0 auto;
    left: 50%;
    transform: translate(-50%, 0);
  }
`;

ConnectingBlock.Top.Double.Img = styled.div``;
ConnectingBlock.Top.Double.Text = styled.div``;
ConnectingBlock.Top.Double.Item = styled.div`
  margin-bottom: 10px;
  padding-left: 18px;
  p {
    text-align: left;
    margin: 0;
  }
`;
ConnectingBlock.Top.Subtext = styled.div`
  margin-bottom: 12px;
  color: #050237;
  opacity: 0.7;
`;
ConnectingBlock.Bottom = styled.div``;

ConnectingBlock.Little = styled.div`
  margin-bottom: 20px;
  color: ${purpleColor};
`;

ConnectingBlock.Bottom.Text = styled.div`
  margin-bottom: 20px;
`;

ConnectingBlock.Bottom.Button = styled.div``;

export { ConnectingBlock };
